<template>
  <div class="d-flex flex-column">
    <div class="review-plan__title heading-h2-24-semi text-light-high mb-4 mt-5">
      {{$t('downgrade.reviewPlan.heading', {plan: choosedPlanText})}} 
    </div>
    <div class="review-plan__body d-flex flex-column">
      <!-- unlimited product pages -->
      <!-- <ReviewPlanCard :isUnpublish="true" v-if="isEnterpriseToBuild || isOptimizeToBuild || isAdvancedToBuild">
        <template #title>{{$tc('downgrade.reviewPlan.unpublishPage.heading')}}</template>
        <template #description>{{$tc('downgrade.reviewPlan.unpublishPage.desc')}}</template>
      </ReviewPlanCard> -->

      <!-- exclusive templates -->
      <!-- <ReviewPlanCard v-if="isOptimizeToBuild || isAdvancedToBuild">
        <template #title>{{$tc('downgrade.reviewPlan.exclusiveTemplate.heading')}}</template>
        <template #description>{{$tc('downgrade.reviewPlan.exclusiveTemplate.desc')}}</template>
      </ReviewPlanCard> -->

      <!-- fewer campagins -->
      <ReviewPlanCard :isCampaign="true" v-if="isOptimizeToBuild || isAdvancedToBuild">
        <template #title>{{$tc('downgrade.reviewPlan.fewerCampaign.heading')}}</template>
        <template #description>
          {{$tc('pricing.20campaigns')}} ->
          <span class="text-light-high weight-500">{{campaignLimit}} {{$tc('lowerCase.campaign', 1)}}</span>
        </template>
      </ReviewPlanCard>

      <!-- unlimited save & export -->
      <ReviewPlanCard v-if="isOptimizeToBuild">
        <template #title>{{$tc('downgrade.reviewPlan.unlimitedSaveAndExport.heading')}}</template>
        <template #description>
          {{$t('downgrade.reviewPlan.unlimitedSaveAndExport.limit', {limit: 300})}} ->
          <span class="text-light-high weight-500">{{$t('downgrade.reviewPlan.unlimitedSaveAndExport.limit', {limit: 30})}}</span>
        </template>
      </ReviewPlanCard>

      <ReviewPlanCard v-if="isEnterpriseToBuild">
        <template #title>{{$tc('downgrade.reviewPlan.unlimitedSaveAndExport.heading')}}</template>
        <template #description>
          {{$tc('downgrade.reviewPlan.unlimitedSaveAndExport.desc')}} ->
          <span class="text-light-high weight-500">{{$t('downgrade.reviewPlan.unlimitedSaveAndExport.limit', {limit: 30})}}</span>
        </template>
      </ReviewPlanCard>

      <ReviewPlanCard v-if="isEnterpriseToOptimize">
        <template #title>{{$tc('downgrade.reviewPlan.unlimitedSaveAndExport.heading')}}</template>
        <template #description>
          {{$tc('downgrade.reviewPlan.unlimitedSaveAndExport.desc')}} ->
          <span class="text-light-high weight-500">{{$t('downgrade.reviewPlan.unlimitedSaveAndExport.limit', {limit: 300})}}</span>
        </template>
      </ReviewPlanCard>

      <!-- unlimited campaigns -->
      <ReviewPlanCard :isCampaign="true" v-if="isEnterpriseToOptimize || isEnterpriseToBuild">
        <template #title>{{$tc('downgrade.reviewPlan.unlimitedCampaign.heading')}}</template>
        <template #description>
          {{$tc('downgrade.reviewPlan.unlimitedCampaign.desc')}} ->
          <span class="text-light-high weight-500" v-if="isEnterpriseToOptimize">{{$tc('pricing.20campaigns')}}</span>
          <span class="text-light-high weight-500" v-else>{{campaignLimit}} {{$tc('lowerCase.campaign', 1)}}</span>
        </template>
      </ReviewPlanCard>

      <!-- priority support -->
      <ReviewPlanCard v-if="isEnterpriseToOptimize || isEnterpriseToBuild">
        <template #title>{{$tc('downgrade.reviewPlan.prioritySupport.heading')}}</template>
        <template #description>{{$tc('downgrade.reviewPlan.prioritySupport.desc')}}</template>
      </ReviewPlanCard>
    </div>
    <div class="review-plan__actions d-flex mt-1">
      <button class="btn btn-default btn-outline mr-2 px-3" @click="backToViewPlan">{{$tc('downgrade.backToViewPlan')}}</button>
      <button
        class="btn btn-default btn-danger2 px-3"
        :class="{'disabled-light': isDisableConfirm}"
        :disabled="isDisableConfirm"
        @click="goToConfirmation"
      >
        {{$tc('downgrade.confirmChange')}}
      </button>
    </div>
  </div>
</template>

<script>
import {mapMutations, mapActions, mapState} from "vuex";
import { mutations} from "@/store/downgrade/types";
import ReviewPlanCard from "../components/ReviewPlanCard.vue";
import choosedPlanStatus from "../mixins/choosedPlanStatus";
import unpublishStatus from "../mixins/unpublishStatus";
import { PLAN_NO } from "@/contants/plan";

export default {
  name: 'ReviewPlan',
  components: {
    ReviewPlanCard,
  },
  mixins: [choosedPlanStatus(), unpublishStatus()],
  data() {
    return {
      campaignLimit: '01',
    }
  },
  computed: {
    ...mapState("downgrade", {
      choosedPlan: state => state.choosedPlan,
    }),
    isDisableConfirm() {
      const isDisableConfirm = (this.isNeedToUnpublishProduct || this.isNeedToUnpublishArticle) && !this.isEnterpriseToOptimize;
      this.setDisabledConfirm(isDisableConfirm);
      return isDisableConfirm;
    },
    choosedPlanText() {
      switch (this.choosedPlan) {
        case PLAN_NO.OPTIMIZE:
          return this.$t('downgrade.confirm.choosedPlan', {plan : this.$t('dataNewPlan.plan.optimize')});
        default:
          return this.$t('downgrade.confirm.choosedPlan', {plan : this.$t('dataNewPlan.plan.build')});
      }
    }
  },
  created () {
    const isDowngradeToBuildPlan = this.isEnterpriseToBuild || this.isOptimizeToBuild || this.isAdvancedToBuild;
    const pageCountDoesNotExist = !this.shopInfo.publishedArticlePagesCount && !this.shopInfo.publishedProductPagesCount;
    if (isDowngradeToBuildPlan && pageCountDoesNotExist) {
      this.whoAmI({isLoading: false});
    };
  },
  methods: {
    ...mapMutations("downgrade", {
      setDisabledConfirm: mutations.SET_DISABLED_CONFIRM,
    }),
    ...mapActions("account", {
      whoAmI: "accountWhoAmI",
    }),
    backToViewPlan() {
      this.$emit('backToViewPlan');
    },
    goToConfirmation() {
      this.$emit('goToConfirmation');
    }
  },
}
</script>
